<template>
  <div
    class="picshow-content"
    :class="{ light : light }"
  >
    <div class="pic-main">
      <img :src="pic.path | picurl">
    </div>

    <div class="btn-close" @click="$emit('close')">
      <img src="@/assets/img/close-x.png">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pic: Object,
    light: Boolean
  },
  filters: {
    picurl(path) {
      const host = location.hostname === "shadow.caa.edu.cn"
        ? ""
        : "http://shadow.caa.edu.cn";

      return host + path;
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/base";
.picshow-content {
  @include pageset;
  left: 0;
  padding-bottom: 1rem;
  color: $text-picinfo;
  background-color: rgba(0, 0, 0, 0.75);
  overflow-y: auto;

  &.light {
    background-color: rgba(255, 255, 255, 0.9);
  }

  .pic-main {
    height: 80vh;
    padding: 4rem 1rem 1rem;
    text-align: center;
    box-sizing: border-box;
    @include img-fluid;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .btn-close {
    position: absolute;
    z-index: 200;
    top: 4rem;
    right: 1rem;
    width: 2rem;
    height: 2rem;

    @include img-fluid;
  }
}
</style>
